<template lang="pug">
    v-card.mb-5
        v-layout(column wrap)
            v-flex(md6)
                v-combobox(
                    chips
                    clearable
                    deletable-chips
                    no-data-text='Sin notas de credito sugeridas.'
                    item-text='name_case'
                    item-value='number'
                    :items='saleCreditNotes'
                    :return-object='false'
                    single-line
                    outline
                    v-model="number"
                )
            v-flex()
                v-btn.white--text( color="orange accent-2" @click='cleanCurrentFolio()') Limpiar Folio
                v-btn(color='primary' @click='submitForm' ) Buscar Folio Nota de Crédito
</template>

<script>
/* services */
import CreditNoteService from '@/services/API/creditNote/creditNoteService'
/* vuex */
import { mapActions } from 'vuex'
/* mixins */
import SnackbarModalUtils from '@/mixins/reusable_mixins/SnackbarModalUtils'
export default {
    name: 'credit-note-search',
    props: {
        saleCreditNotes: {
            type: Array,
            default: () => [],
        }
    },
    data: function() {
        return {
            number: null,
        }
    },
    // computed: {},
    methods: {
        cleanCurrentFolio() {
            this.number = null
            this.checkResponseFolio([])
        },
        // -- UI Modification
        // -- Data fetching
        submitForm() {
            if (this.checkNumber()) {
                this.sendFolio()
            }
        },
        /**
         * Verify if user has added folio.
         */
        checkNumber() {
            if (this.number === null) {
                //show snack alert
                return false
            }
            return true
        },
        async sendFolio() {
            this.snackLoading(
                'Buscando Nota de crédito',
                'Espere un momento por favor'
            )
            let response = await CreditNoteService.getCreditNoteByFolio(
                this.number
            )
            this.checkResponseFolio(response)
            this.resetSnackbarState()
        },
        checkResponseFolio(response) {
            response.length === 0
                ? this.$emit('creditNote', false)
                : this.$emit('creditNote', response[0])
        },
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // watch: {},
    // components: {},
    mixins: [SnackbarModalUtils],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>